var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStocksIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39998 30.0867H68.4",
    stroke: "url(#paint0_linear_103_18471)",
    strokeWidth: 0.529201,
    strokeDasharray: "2.12 2.12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30.4834V29.2462L14.2973 38.0831L15.8289 22H16.9776L17.9986 25.358L19.2749 29.2462L20.296 31.8973L22.0828 27.3021H24.7631L27.0604 31.8973L28.4644 41.4411L30.2512 46.7433L31.6551 41.4411H33.442L35.1012 49.3943L36.6327 52.7523H38.4196L39.6959 46.7433L41.3551 45.3294L42.5037 49.3943L43.7801 46.7433L45.9498 45.3294L47.7366 41.4411L49.5234 42.855L52.9695 41.4411L55.3945 45.3294L56.7984 36.139L58.7129 38.0831L60.755 36.139L63.5628 38.0831L64.9668 42.855L66.2431 41.4411H68.1575",
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_18471",
    x1: 5.39998,
    y1: 30.0867,
    x2: 68.4,
    y2: 30.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838442,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocksIcon);
export default __webpack_public_path__ + "static/media/StocksIcon.7d0a86d68ae2191a6579d77701f629ae.svg";
export { ForwardRef as ReactComponent };